import React from "react";
import { Layout } from "src/components/layout/Layout";
import { ModuleRouter } from "src/components/molecules";
import { VehicleManagementRoute } from "./vehicle-management.routes";

export function Management() {
  return (
    <Layout>
      {VehicleManagementRoute.subRoutes && (
        <ModuleRouter
          subRoutes={VehicleManagementRoute.subRoutes}
          path={VehicleManagementRoute.path}
        />
      )}
    </Layout>
  );
}
